import { render, staticRenderFns } from "./photo-img.vue?vue&type=template&id=86b1349e&scoped=true&lang=pug&"
import script from "./photo-img.vue?vue&type=script&lang=js&"
export * from "./photo-img.vue?vue&type=script&lang=js&"
import style0 from "./photo-img.vue?vue&type=style&index=0&id=86b1349e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b1349e",
  null
  
)

export default component.exports